import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from "../../../components/RequestDefinition";

const getSalesOrderRequest: RequestExample = {
    title: {
        verb: 'GET',
        endpointUrl: '/api/sales-orders/:id',
    },
    curl:
        `curl --location \\
--request GET '<YOUR SERVER>/api/sales-orders/:id' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

const getSalesOrdersResponse: Json = {
    title: 'RESPONSE',
    json: {
        title: 'THE SALES ORDER OBJECT',
        json: {
            "id": 72,
            "number": "10075",
            "carrier": {
                "id": 4,
                "name": "Fedex",
                "service": {
                    "id": 8,
                    "name": "Ground"
                }
            },
            "fobPointName": "Origin",
            "paymentTerms": {
                "id": 5,
                "name": "2% 10 NET 40"
            },
            "customer": {
                "id": 43,
                "name": "Big Al's Bike Shop"
            },
            "vendorPoNumber": "",
            "customerPoNumber": "",
            "customerContact": "Big Al's Bike Shop",
            "salesperson": {
                "id": 1,
                "name": "admin"
            },
            "deliverTo": "Big Al's Bike Shop",
            "revisionNumber": 1,
            "lastModified": {
                "username": "",
                "dateLastModified": "2025-06-13T23:38:07.239-06"
            },
            "dateCreated": "2025-03-28T08:54:22.000-06",
            "dateScheduled": "2025-03-28T08:54:22.000-06",
            "dateCompleted": "2025-03-28T08:54:22.000-06",
            "dateExpired": "2025-04-28T08:54:22.000-06",
            "totalTax": "0",
            "totalPrice": "50",
            "mcTotalTax": "0",
            "mcTotalPrice": "50",
            "totalIncludesTax": false,
            "locationGroup": {
                "id": 5,
                "name": "SLC"
            },
            "note": "",
            "url": "",
            "email": "",
            "phone": "801-932-1101",
            "shipToAddress": {
                "name": "Big Al's Bike Shop",
                "street": "Big Al's Bike Shop",
                "city": "Seattle",
                "state": "WA",
                "postalCode": "98199",
                "country": "UNITED STATES"
            },
            "billToAddress": {
                "name": "Big Al's Bike Shop",
                "street": "Big Al's Bike Shop",
                "city": "Seattle",
                "state": "WA",
                "postalCode": "98199",
                "country": "UNITED STATES"
            },
            "status": "Fulfilled",
            "class": {
                "id": 1,
                "name": "None"
            },
            "shipTerms": "Prepaid & Billed",
            "type": "Standard",
            "soItems": [
                {
                    "id": 160,
                    "product": {
                        "id": 81,
                        "name": "B203",
                        "description": "Basic Brake Cables"
                    },
                    "type": {
                        "id": 10,
                        "name": "Sale"
                    },
                    "uom": {
                        "id": 1,
                        "name": "Each",
                        "abbreviation": "ea"
                    },
                    "lineNumber": 1,
                    "customerPartNumber": "",
                    "unitPrice": "10",
                    "totalTax": "0",
                    "totalPrice": "50",
                    "mcTotalTax": "0",
                    "mcTotalPrice": "0",
                    "taxRate": {
                        "id": 1,
                        "name": "None",
                        "rate": 0.0
                    },
                    "dateLastFulfilled": "2025-03-28T08:54:22.000-06",
                    "dateScheduled": "2025-03-28T08:54:22.000-06",
                    "revision": "",
                    "note": "",
                    "status": "Fulfilled",
                    "quantity": "5",
                    "quantityFulfilled": "5",
                    "quantityPicked": "0",
                    "class": {
                        "id": 1,
                        "name": "None"
                    },
                    "customFields": []
                }
            ],
            "customFields": [
                {
                    "id": 20,
                    "name": "Custom",
                    "type": "Text"
                }
            ]
        },
    },
};

const data: RequestDefinitionData = {
    id: 'get-sales-order',
    title: 'Get a sales order',
    description: 'Retrieves the details of an existing sales order. You provide the unique sales order ID. Requires SO_VIEW access right. Sales orders in location groups the user has read-only access to are returned; a 403 is returned only when the user has no access at all to the sales order\'s location group. Returns 404 if the sales order is not found.',
    endpoint: {
        verb: 'GET',
        path: '/sales-orders/:id',
        tooltip: 'Get a sales order',
    },
    attributes: [],
    requestObject: getSalesOrderRequest,
    responseObject: getSalesOrdersResponse,
};

export default data;
